module.exports = __webpack_public_path__ + "static/media/live-tracking-img.6f5f9b83.png";